<template>
  <div>
    <LoadingSpinner v-if="!completeLoading" />
    <div v-else>
      <div class="col-12 px-0">
        <table class="table table-striped">
          <thead class="thead-dark">
            <td></td>
            <td></td>
            <td>
              <strong>Client ID</strong>
            </td>
            <td>
              <strong>Client name</strong>
            </td>
            <td>
              <strong>Sales representative</strong>
            </td>
            <td>
              <strong>{{ $t("lang.token.order_website") }}</strong>
            </td>
            <td>
              <strong>Sales status</strong>
            </td>
            <td>
              <strong>Calendar link</strong>
            </td>
            <td>
              <strong>Landing page link</strong>
            </td>
            <td>
              <strong>Create sub-domain</strong>
            </td>
            <td>
              <strong>Publish</strong>
            </td>
            <td>
              <strong>Verified</strong>
            </td>
          </thead>
          <tbody>
            <tr v-for="(client, index) of list" :key="index">
              <td>
                {{ index + 1 }}
              </td>
              <td>
                <span
                  v-if="client.task_open_hours !== null"
                  class="badge"
                  :class="taskOpenHoursClass(client.task_open_hours)"
                >
                  {{ client.task_open_hours }} h
                </span>
              </td>

              <td>{{ client.client_id }}</td>
              <td>
                <span class="text-primary cursor-pointer">
                  <a :href="'/clients/' + client.client_id" target="_blank">
                    {{ client.company_name }}
                  </a>
                </span>
              </td>
              <td>
                <span class="text-primary cursor-pointer">
                  <a :href="'/users/' + client.sales_id" target="_blank">
                    {{ client.sales_last_name }}, {{ client.sales_first_name }}
                  </a>
                </span>
              </td>
              <td>
                <span class="text-primary cursor-pointer">
                  <a :href="client.target_website" target="_blank">
                    {{ client.target_name }}
                  </a>
                </span>
              </td>
              <td>{{ client.user_status_name }}</td>
              <td>
                <p class="text-primary cursor-pointer">
                  <a :href="client.calendar_link" target="_blank">
                    {{ client.calendar_link }}
                  </a>
                </p>

                <i
                  class="icon icon-clipboard cursor-pointer mr-2"
                  :title="$t('lang.general.copytoclipboard') + ': Link'"
                  @click="
                    copyCalendarLink(
                      getCalendarLink(client.domaincalendar, client.id)
                    )
                  "
                ></i>
                <i
                  class="icon icon-file-code-o cursor-pointer"
                  :title="
                    $t('lang.general.copytoclipboard') +
                    ': ' +
                    $t('lang.general.embedcode')
                  "
                  @click="
                    copyEmbedCode(
                      getCalendarLink(client.domaincalendar, client.id)
                    )
                  "
                ></i>
              </td>
              <td>
                <span class="text-primary cursor-pointer">
                  <a :href="client.landing_link" target="_blank">
                    {{ client.landing_link }}
                  </a>
                </span>
              </td>
              <td class="text-center">
                <button
                  v-if="client.broken_link || client.landing_link.length === 0"
                  class="btn btn-sm btn-primary"
                >
                  <a
                    href="https://www.ovh.com/manager/#/web/domain/l-p.page/zone"
                    target="_blank"
                  >
                    Create sub-domain
                  </a>
                </button>
                <i v-else class="icon-circle text-success"></i>
              </td>
              <td class="text-center">
                <button
                  v-if="
                    client.broken_link === '1' ||
                    client.landing_link.length === 0
                  "
                  class="btn btn-sm btn-primary"
                >
                  <a
                    href="https://app.swipepages.com/s/615c14b28dcf7f0011c43087/sites/lpages/new"
                    target="_blank"
                  >
                    Publish
                  </a>
                </button>
                <i v-else class="icon-circle text-success"></i>
              </td>
              <td
                v-if="
                  client.broken_link != '1' && client.landing_link.length > 0
                "
              >
                <vue-form-generator
                  :schema="schemaCloseOrder"
                  :model="list[index].landing_page_verified"
                  @model-updated="updateLinkBrokenToUser(index)"
                >
                </vue-form-generator>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { adminService } from "@/_services";
import VueFormGenerator from "vue-form-generator";

export default {
  name: "AgencyLandingPageList",
  components: {
    LoadingSpinner,
    "vue-form-generator": VueFormGenerator.component,
  },
  data() {
    return {
      completeLoading: false,
      list: [],
      updateLink: false,
      linkVerified: {},
      schemaCloseOrder: {
        fields: [
          {
            type: "switch",
            model: "updateLink",
            featured: true,
            id: "closed",
            textOn: " ",
            textOff: " ",
            valueOn: "1",
            valueOff: "0",
            disabled: (model) => model.updateLink === "1",
            styleClasses: "col-md-12",
          },
        ],
      },
    };
  },

  created() {
    this.getLandingPage();
  },
  methods: {
    updateLinkBrokenToUser(index) {
      //Obtengo los datos completos de la fila de acuerdo al index del array list
      const value = this.list.find((element, i) => i === index);

      const dataToSave = {
        client_id: value.client_id,
        url: value.landing_link,
      };
      adminService.updateStatusLandingPage(dataToSave).then((result) => {
        if (result.result) {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            showConfirmButton: false,
            timer: 3000,
          });
        } else {
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            showConfirmButton: true,
          });
        }
        //this.list.find( (element, i) => i === index).broken_link=null
      });
    },
    getLandingPage() {
      this.completeLoading = false;
      adminService.getLandingPage().then((res) => {
        this.list = res.map((el) => {
          return {
            ...el,
            linkVerified: { updateLink: "0" },
            landing_page_verified:
              el.landing_page_verified === "1"
                ? { updateLink: "1" }
                : { updateLink: "0" },
          };
        });
        this.completeLoading = true;
      });
    },
    copyCalendarLink(calendar_link) {
      if (this.copyToClipboard(calendar_link)) {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.general.copiedtoclipboard"),
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    copyEmbedCode(calendar_link) {
      var copyText =
        '<div style="min-width:320px;height:630px;"><iframe width="100%" height="100%" style="border:0" src="' +
        calendar_link +
        '" frameborder="0" allowfullscreen></iframe></div>';
      if (this.copyToClipboard(copyText)) {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.general.copiedtoclipboard"),
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    getCalendarLink(domain, id) {
      let sales_id = btoa(id);
      return "https://" + domain + "/calendar/" + sales_id;
    },
    copyToClipboard(text) {
      if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    taskOpenHoursClass(task_open_hours) {
      if (task_open_hours < 24) {
        return "badge-warning";
      }
      return "badge-danger";
    },
  },
};
</script>
<style scoped>
.red-background-switch {
  background-color: red;
  border-color: red; /* Cambia el color del borde si es necesario */
  /* Otros estilos personalizados según tus necesidades */
}
.switch-inactivo {
  background-color: rojo; /* Cambia "rojo" al color de fondo deseado */
  border-color: rojo; /* Cambia el color del borde si es necesario */
  /* Otros estilos personalizados según tus necesidades */
}
</style>
